import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { AffiliateEditor } from "@/affiliates/AffiliateEditor";
import {
  AffiliatesPage,
  parseAffiliatesSearch,
} from "@/affiliates/AffiliatesPage";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/affiliates_/new",
)({
  validateSearch: parseAffiliatesSearch,
  component: NewAffiliateRoute,
});

function NewAffiliateRoute(): ReactNode {
  const { q } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AffiliatesPage
      query={q ?? ""}
      creating
      onQueryChange={(query) => {
        void navigate({
          replace: true,
          search: { q: query === "" ? undefined : query },
        });
      }}
    >
      <AffiliateEditor query={q} />
    </AffiliatesPage>
  );
}
